import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { globalPropTypes, checkPermissions, FEATURE_MA_YC_APPLY } from 'helpers';

import { Header, Tabs } from 'components';
import { loadYcPeopleBarCreator } from 'store/actionsCreators';
import { useTranslation } from 'react-i18next';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.yc.people',
    url: '/yc/people',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.yc.people.youngCrews',
    path: '/yc/people/users',
    key: 'users',
  },
  {
    title: 'navigation.tabs.yc.people.list',
    path: '/yc/people/list',
    key: 'people',
  },
  {
    title: 'navigation.tabs.ma.people.youngCrew',
    path: '/yc/people/members',
    key: 'members',
  },
  {
    title: 'navigation.tabs.ma.people.applied',
    path: '/yc/people/applied',
    key: 'applied',
  },
];

const People = ({ routes, loadBar, bar, userPermissions }) => {
  const { t } = useTranslation();
  useEffect(() => {
    loadBar();
  }, []);

  // "Applied for Membership" triages join requests, which are held back until
  // the client releases them.
  const visibleTabs = FEATURE_MA_YC_APPLY
    ? initialTabs
    : initialTabs.filter((tab) => tab.key !== 'applied');

  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(visibleTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/yc/people', firstTabPath);
  const [renderForbidden] = useExactRedirect('/yc/people', '/forbidden');

  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={t('page.yc.people.title')}
        renderActions={({ Button: ButtonRender }) =>
          checkPermissions(
            {
              roles: ['yc_manage_members_people'],
            },
            userPermissions,
          ) ? (
            <ButtonRender secondary as={Link} to="/yc/people/add">
              {t('page.yc.people.addYcUserButton')}
            </ButtonRender>
          ) : null
        }
      />
      <Tabs items={tabs} />
      {!firstTabPath ? renderForbidden() : null}
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

People.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  loadBar: PropTypes.func.isRequired,
  bar: PropTypes.shape({
    users: PropTypes.number,
    list: PropTypes.number,
    members: PropTypes.number,
    applied: PropTypes.number,
  }).isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

People.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ yc, user }) => ({
  bar: yc.people.bar,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadBar: () => dispatch(loadYcPeopleBarCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(People);
